export default __webpack_public_path__ + "static/media/jornadaSocioProfessores.1ee88424.svg";